<template>
  <FeatureDetailPage feature-key="check-ins" />
</template>
